// import devtools from "@vue/devtools";
import Vue from "vue";
import App from "./App.vue";
import router from "@/router/router";
import store from "@/store";
import "./utils/rem.js";
import { RouterTrasitionPlugin } from "@/plugins/routerTransition";
import { InstanceMethods } from "@/plugins/instanceMethods";
import { ImgSrcChangePlugin } from "@/plugins/imgSrcChange";
import * as ResPlugin from "@/plugins/resPlugin";
import EventBus from "@/utils/eventBus";
import { isIos } from "@/utils/lodash";
import BakcPress from "@/utils/backPress";
import { initialStatusBarHeight } from "@/utils/statusBarHeight";
import VueAwesomeSwiper from "vue-awesome-swiper";
import * as types from "@/store/constants/types";
import localStorageHelper from "@/localstorage/localstorage";
import { SvgIconPlugin } from "@/plugins/svgIcon";
import { RollbarPlugin } from "@/plugins/rollbar";
import VueLazyload from "vue-lazyload";
import { Swipe, SwipeItem } from "vant";
import GeneralUtils from "@/utils/generalUtils";
import Http from "@/api/http/fetch/index";
import handleNoticeRouterPush from "@/utils/handleNoticeRouterPush";
import HandleNoticeinit from "@/utils/handleNoticeInit";

// if (process.env.NODE_ENV === "development") {
//   devtools.connect("192.168.8.17");
// }

Vue.use(RouterTrasitionPlugin, router);
Vue.use(InstanceMethods);
Vue.use(ImgSrcChangePlugin);
Vue.use(VueAwesomeSwiper);
Vue.use(ResPlugin.plugin);
Vue.use(SvgIconPlugin);
Vue.use(Swipe).use(SwipeItem);
Vue.use(VueLazyload, {
  lazyComponent: true,
  observer: true,
  observerOptions: {
    rootMargin: "30px",
    threshold: 0
  }
});
//测试服的token
let accessToken: string = "420f981539ae4977b63dd9f805b36856";
//production下：
if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_GOOGLE_ANALYTICS === "ON"
) {
  accessToken = "0ccc84d2d710437b95f1d16c24a22db3";
}

if (process.env.NODE_ENV === "production") {
  Vue.use(RollbarPlugin, {
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: process.env.VUE_APP_VERSION,
    payload: {
      client: {
        javascript: {
          code_version: process.env.VUE_APP_VERSION
        }
      }
    }
  });
}

//禁止IOS的body的滚动；(IOS禁止)
isIos()
  ? (document.ontouchmove = event => {
      event.preventDefault();
    })
  : void 0;

function handleNotice() {
  Http.HandleNotification((result: any) => {
    try {
      console.log("点击了通知，", result);
      const { response, callBack } = result;
      let data = JSON.parse(response);
      console.log('HandleNotification', data);
      data.status === "ok" ? (data = JSON.parse(data.msg)) : void 0;
      //================= push dialog ==================
      if (data) {
        handleNoticeRouterPush(data);
      }
    } catch (error) {
      console.log("HandleNotification error:", error);
    }
  });
}

/**
 * 挂载Toast的全局方法:
 */
Vue.prototype.$Toast = {
  show: (payload: any) => {
    EventBus.$emit("toast-show", payload);
  },
  hide: () => {
    EventBus.$emit("toast-hide");
  }
};

Vue.config.errorHandler = (err, vm, info) => {
  Vue.prototype.$rollbar.error(err);
};

const bridge = Vue.prototype.$native;

function initialSetting() {
  store
      .dispatch(types.INITIAL_SETTING)
      .then(() => {
        EventBus.$emit("initial—status", true);
        handleNotice();
      })
      .catch((error: any) => {
        // this.initial();
      });
}

//更新app启动的次数
store.commit(types.UPDATE_APP_LAUNCH_TIME);
console.log("UPDATE_APP_LAUNCH_TIME:",new Date().valueOf())

/*
 * 实例化 vue
 */
function initialVue(params: any = {}) {
  new Vue({
    router,
    store,
    render: h => h(App),
    created() {
      bridge.DomReady().then((data: any) => {
          // // data 返回的是需要处理的 通知数据
          // if (data === "no notification info" || data.type) {
          //   localStorageHelper.set("is_app_version_ok", true);
          // } else {
          //   localStorageHelper.set("is_app_version_ok", false);
          // }
          // console.log('INITIAL_SETTING created===', new Date().getTime());
          // store
          //     .dispatch(types.INITIAL_SETTING, { notices: data })
          //     .then(() => {
          //       handleNotice();
          //     })
          //     .catch((error: any) => {});
          console.log("domready", data);
          //处理app是死的时候初始化的逻辑，以及是否从通知进入
          if (data === "no notification info") {
            console.log("app死的时候，直接打开了app");
            localStorageHelper.set("is_app_version_ok", true);
            initialSetting();
          } else if (data.type) {
            console.log("app死的时候点击了通知");
            localStorageHelper.set("is_app_version_ok", true);
            try {
              //初始化通知的setting配置
              HandleNoticeinit().then(() => {
                EventBus.$emit("initial—status", true);
                handleNoticeRouterPush(data);
                handleNotice();
              });
            } catch (error) {
              console.log("HandleNotification error:", error);
            }
          } else {
            console.log("不支持本地通知");
            localStorageHelper.set("is_app_version_ok", false);
            initialSetting();
          }
    });
    }
  }).$mount("#app");

  //=====================安卓返回的监听=================
  BakcPress.initial();
}

/**
 *  在JSBridge初始化成功后实例化Vue:
 */
bridge
  .initial()
  .then(() => {
    initialStatusBarHeight();

    // 如果是新包有launchParams，则直接开始初始化， 否则拉取先拉取本地setting
    bridge.LaunchParam().then((params: any) => {
      console.log('bridge.LaunchParam result', params);
      if (isIos() && params && params.status && params.status === "ok") {
        store.state.startUpPolicyModule.launchParams = params;
        _continueExecute('launch');
      } else if (!isIos() && params && params.hasOwnProperty('vip_before_welcome')) {
        store.state.startUpPolicyModule.launchParams = params;
        _continueExecute('launch');
      } else {
        _continueExecute()
      }
    });
  })
  .catch((err: any) => {
    console.log(err);
  });

function _continueExecute(params?: any) {
  bridge.LoadSetting().then((settings: any) => {
    store.commit(types.RECEIVE_GX_SETTING_DATA, settings);
    if (!params) {
      const launch = settings.launch ? settings.launch : null;
      store.state.startUpPolicyModule.settingLaunchParams = launch;
    }
    initialVue();
  });
}
